import React from "react";
import BftLogo from "./icons/logo.svg";
import SslLogo from "./icons/ssl.svg";
import SecurityIcon from "./icons/security.svg";

import * as styles from "./FooterAppStyle.module.scss";
import {
  unsignedUkExploreLinks,
  getProductsSections,
  getUkProductSections,
  HOMEPAGE_URL,
  legalLinks,
  socialMediaLinks,
  getExploreLinks,
} from "./FooterApp.const";
import { FooterInformationsBlock } from "./components/FooterInformationsblock";
import { IProfile } from "@profile/pages/AccountPage/IProfileData";

const FooterApp = ({
  country,
  profile,
}: {
  country?: string;
  profile?: IProfile;
}) => {
  const isUk = country === "GB";
  const userSignedIn = !!profile;

  const profileSlug = `/profile/${profile?.slug}`;
  const exploreSections = getExploreLinks(isUk, !userSignedIn && isUk);

  const productsSections = isUk
    ? getUkProductSections(profileSlug)
    : getProductsSections(profileSlug);

  return (
    <footer className={styles.footer}>
      <div className={styles.footer__container}>
        <div className={styles.footer__content}>
          <div className={styles.footer__logoSection}>
            <BftLogo className={styles.footer__logo} />
            <p className={styles.footer__copyrightText}>
              Copyright © 2011-{new Date().getFullYear()} Bnk To The Future
            </p>
            <div className={styles.footer__socialLinks}>
              {socialMediaLinks.map((smLink) => (
                <a
                  key={smLink.alt}
                  href={smLink.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {smLink.icon}
                </a>
              ))}
            </div>
          </div>

          <div className={styles.footer__products}>
            <p className={styles.footer__title}>Our products</p>
            {productsSections.map((section, idx) => (
              <div
                className={styles.footerProductsSection}
                key={`productSections-${idx}`}
              >
                <p className={styles.footerSectionTitle}>{section.title}</p>
                <div className={styles.footerSectionLinks}>
                  {section.links.map((sectionLink, sectionIdx) => (
                    <a
                      key={`productSections-${idx}-${sectionIdx}`}
                      className={styles.footerSectionLink}
                      href={sectionLink.url ?? HOMEPAGE_URL}
                      target="_blank"
                    >
                      {sectionLink.label}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className={styles.footer__explore}>
            <p className={styles.footer__title}>Explore Bnk To The Future</p>
            <div className={styles.footer__links}>
              {exploreSections.map((link, index) => (
                <a
                  key={`exploreLink-${index}`}
                  href={link.url}
                  className={styles.footer__link}
                >
                  {link.label}
                </a>
              ))}
            </div>

            <div className={styles.footer__additionalLinks}>
              <a
                className={styles.footer__link}
                href={`${HOMEPAGE_URL}/blog`}
                target="_blank"
              >
                Announcements
              </a>

              <div>
                <a
                  className={styles.footer__link}
                  href="/support"
                  target="_blank"
                >
                  Support
                </a>
              </div>
            </div>
          </div>

          <div className={styles.footer__legal}>
            <p className={styles.footer__title}>Legal</p>
            <div className={styles.footer__links}>
              {legalLinks.map((link, index) => (
                <a
                  key={`legalLink-${index}`}
                  href={link.url}
                  className={styles.footer__link}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {isUk && (
          <div className={styles.footer__security}>
            <SecurityIcon />
            <span>
              This Financial Promotion has been approved by Archax LTD on
              February 12, 2025
            </span>
          </div>
        )}

        <FooterInformationsBlock />

        <div className={styles.footer__ssl}>
          <SslLogo className={styles.footer__sslLogo} />
        </div>
      </div>
    </footer>
  );
};

export default FooterApp;
